import { withProps } from 'recompose';
import { usePortletTranslations } from 'js/components/system/Portlet';

export default withProps((props) => {
    const {
        registrationStatus,
        displayRegStatus,
        prizeFund,
        leaderboardStartTime: startTime,
        leaderboardEndTime: endTime
    } = props;

    const translate = usePortletTranslations();
    const t = (key, ...restArgs) => translate(`card.${key}`, ...restArgs);

    const cardInfoItems = [
        {
            label: t('prize'),
            value: prizeFund
        },
        {
            label: t('regStatus.label'),
            value: displayRegStatus && t(`regStatus.${registrationStatus.toLowerCase()}`)
        },
        {
            value: true,
            countDown: { endTime, startTime }
        }
    ];

    return {
        cardInfoItems: cardInfoItems
            .filter(({ value }) => value)
            .reduce((memo, item, idx) => memo.concat(idx === 1 ? [{ breakLine: true }, item] : item), [])
    };
});
